import Flux from 'lib/flux';

export default Flux.createConstants({
  serviceMessages: ['PREVIEW'],
});
